export interface RegistrationUnitOverrides {
  min_units_per_registration?: number | null;
  max_units_per_registration?: number | null;
}

export function registrationUnitLimitError(limits: RegistrationUnitOverrides): string {
  const min = limits.min_units_per_registration;
  const max = limits.max_units_per_registration;
  if ([min, max].some(value => value !== null && value !== undefined && (!Number.isInteger(value) || value < 0))) {
    return 'Registration units must be a whole number of zero or more.';
  }
  return min !== null && min !== undefined && max !== null && max !== undefined && min > max
    ? 'Maximum registration units must be at least the minimum.' : '';
}

export function resolveRegistrationUnitLimits(
  calendar?: RegistrationUnitOverrides | null,
  programme?: RegistrationUnitOverrides | null,
  module?: RegistrationUnitOverrides | null,
) {
  const sources = [
    { label: 'Module', values: module },
    { label: 'Programme', values: programme },
    { label: 'Student academic calendar', values: calendar },
  ];
  const resolve = (field: keyof RegistrationUnitOverrides, fallback: number) => {
    const source = sources.find(item => item.values?.[field] !== null && item.values?.[field] !== undefined);
    return { value: source?.values?.[field] ?? fallback, source: source?.label ?? 'No limit configured' };
  };
  return {
    min: resolve('min_units_per_registration', 0),
    max: resolve('max_units_per_registration', Infinity),
  };
}
